import { Link, useLocation, useNavigate } from "react-router-dom";
import navItems from "../../Json/header.json";
import AnimatedComponent from "../AnimateComponent";
import { useEffect } from "react";

const LandingFooter = () => {
  //   const { pathname, state } = useLocation();
  //   let url = pathname.split("/");
  //   const navigate = useNavigate();

  //   const handleUrlClick = (e, item) => {
  //     if (item.href.startsWith("#")) {
  //       e.preventDefault(); // Prevent default React Router
  //       const targetId = item.href.replace("#", "");

  //       if (pathname !== "/home") {
  //         navigate("/home", { state: { scrollTo: targetId } });
  //       } else {
  //         const element = document.getElementById(targetId);
  //         if (element) element.scrollIntoView({ behavior: "smooth" });
  //       }
  //     }
  //   };

  //   useEffect(() => {
  //     if (state?.scrollTo) {
  //       const targetId = state.scrollTo;
  //       setTimeout(() => {
  //         const element = document.getElementById(targetId);
  //         if (element) element.scrollIntoView({ behavior: "smooth" });
  //       }, 0);

  //       window.history.replaceState({}, document.title);
  //     }
  //   }, [state]);

  return (
    // <div id="contact" className="w-full flex justify-between bg-lightgray">
    //   <div className="2xl:container mx-auto w-full md:px-14 lg:px-20 px-6 pt-10 sm:pt-20 pb-5 sm:py-20 md:py-[48px] ">
    //     <div className="lg:flex-row flex flex-col gap-5 sm:gap-10 w-full justify-between lg:items-center">
    //       <div className="flex flex-col gap-5 md:gap-2 w-full sm:w-[70%] lg:w-[40%]">
    //         <Link to={"/home"}>
    //           <img
    //             className=" h-[35px] sm:h-[40px]"
    //             src={process.env.PUBLIC_URL + "/images/login/headerlogo.svg"}
    //             alt="xpress_logo"
    //           />
    //         </Link>
    //         <p className="font-semibold text-20 sm:text-24 text-left text-primaryColor">
    //           Get started and elevate your content with integrity-driven checks
    //         </p>
    //       </div>
    //       <div className="flex gap-x-10 gap-y-5 text-left  max-[550px]:grid max-[550px]:grid-cols-3 w-full lg:w-fit">
    //         {navItems.header.map((item, index) => (
    //           <Link
    //             key={index}
    //             to={item.href}
    //             onClick={(e)=>handleUrlClick(e,item)}
    //             target={item.target ? "_" : undefined}
    //             className={`text-16 font-medium text-primaryColor ${
    //               item.hover === url[1] ? "text-orange" : "hover:text-orange "
    //             } `}
    //           >
    //             {item.name}
    //           </Link>
    //         ))}
    //       </div>
    //     </div>
    //     <p className="border-b-[1px] border-footborder my-[30px] sm:my-[48px]"></p>
    //     <div className="flex justify-between items-center max-md:flex-col-reverse max-sm:gap-y-5 max-md:gap-y-10">
    //       <div className="flex items-center gap-6 max-md:w-full max-md:justify-between max-sm:flex-col max-sm:gap-4">
    //         <Link to={"https://www.transforma.in/"} target="_blank">
    //           <img
    //             className="h-[28px]"
    //             src={process.env.PUBLIC_URL + "/images/header/transforma.png"}
    //             alt="transforma_logo"
    //           />
    //         </Link>
    //         <p className="text-primaryColor pt-2 text-16 font-medium">
    //           {window.innerWidth > 769
    //             ? `© Copyright 2025 Transforma. All Rights Reserved.`
    //             : "© 2025 Transforma. All Rights Reserved."}
    //         </p>
    //       </div>
    //       <div className="flex items-center gap-4 ">
    //         <Link
    //           to="https://www.linkedin.com/company/transforma-private-limited"
    //           className="text-16 text-primaryColor"
    //           target="_blank"
    //         >
    //           <img
    //             className="h-[40px]"
    //             src={
    //               process.env.PUBLIC_URL +
    //               "/images/landing-page/footer/Linkedin.svg"
    //             }
    //             alt="linkedin_logo"
    //           />
    //         </Link>
    //         <Link
    //           to="https://www.facebook.com/www.transforma.in"
    //           className="text-16 text-primaryColor"
    //           target="_blank"
    //         >
    //           <img
    //             className="h-[40px]"
    //             src={
    //               process.env.PUBLIC_URL +
    //               "/images/landing-page/footer/facebook.svg"
    //             }
    //             alt="facebook_logo"
    //           />
    //         </Link>
    //         <Link
    //           to="https://twitter.com/i/flow/login?redirect_after_login=%2Ftransformapress"
    //           className="text-16 text-primaryColor"
    //           target="_"
    //         >
    //           <img
    //             className="h-[40px]"
    //             src={
    //               process.env.PUBLIC_URL +
    //               "/images/landing-page/footer/Twitter.svg"
    //             }
    //             alt="twitter_logo"
    //           />
    //         </Link>
    //       </div>
    //     </div>
    //   </div>
    // </div>

    <div
      id="contact"
      className="w-full flex justify-between bg-lightgray text-left"
    >
      <div className=" w-full ">
        <div className="2xl:container mx-auto md:px-14 py-6 lg:px-20 px-6 lg:flex-row flex flex-col gap-5 lg:gap-10 w-full justify-between lg:items-center">
          <div className="flex flex-col xl:flex-row sm:justify-between gap-5 xl:gap-10 xl:w-[55%] xl:items-center ">
            <div className="  w-fit flex flex-col ">
              <Link to={"/home"}>
                <img
                  className="h-[35px] sm:h-[40px]"
                  src={process.env.PUBLIC_URL + "/images/login/headerlogo.svg"}
                  alt="xpress_logo"
                />
              </Link>
              <p className=" text-[8px]  flex gap-1 text-black  justify-end">
                Powered by
                <Link target="_blank" to={"https://www.transforma.in/"}>
                  <img
                    className="h-[9px] sm:h-[10px]"
                    src={
                      process.env.PUBLIC_URL + "/images/logos/Transforma.svg"
                    }
                    alt="xpress_logo"
                  />
                </Link>
              </p>
            </div>
            <p className="text-16 text-secondaryblack">
              Working Hours: Mon-Friday, 6:30 AM to 10:30 PM IST only
            </p>
          </div>
          <div className="flex gap-5 max-sm:flex-col">
            <div className="flex gap-2 min-w-fit">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_483_647)">
                  <path
                    d="M4.16667 3.33325H7.5L9.16667 7.49992L7.08333 8.74992C7.9758 10.5595 9.44039 12.0241 11.25 12.9166L12.5 10.8333L16.6667 12.4999V15.8333C16.6667 16.2753 16.4911 16.6992 16.1785 17.0118C15.866 17.3243 15.442 17.4999 15 17.4999C11.7494 17.3024 8.68346 15.922 6.38069 13.6192C4.07792 11.3165 2.69754 8.25053 2.5 4.99992C2.5 4.55789 2.67559 4.13397 2.98816 3.82141C3.30072 3.50885 3.72464 3.33325 4.16667 3.33325Z"
                    stroke="#040815"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_483_647">
                    <rect width="20" height="20" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
              <div className="flex gap-1 ">
                <a
                  href="tel:+919884006293"
                  className="text-16 text-secondaryblack decoration-none"
                >
                  +91 9884006293
                </a>
                <span>|</span>
                <a
                  href="tel:+1 9083154177"
                  className="text-16 text-secondaryblack  decoration-none"
                >
                  +1 9083154177
                </a>
              </div>
            </div>
            <div className="min-w-fit">
              <a
                href="mailto:info@transforma.in"
                className="flex gap-2 text-secondaryblack text-16"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_483_652)">
                    <path
                      d="M2.5 5.83341C2.5 5.39139 2.67559 4.96746 2.98816 4.6549C3.30072 4.34234 3.72464 4.16675 4.16667 4.16675H15.8333C16.2754 4.16675 16.6993 4.34234 17.0118 4.6549C17.3244 4.96746 17.5 5.39139 17.5 5.83341V14.1667C17.5 14.6088 17.3244 15.0327 17.0118 15.3453C16.6993 15.6578 16.2754 15.8334 15.8333 15.8334H4.16667C3.72464 15.8334 3.30072 15.6578 2.98816 15.3453C2.67559 15.0327 2.5 14.6088 2.5 14.1667V5.83341Z"
                      stroke="#040815"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M2.5 5.83325L10 10.8333L17.5 5.83325"
                      stroke="#040815"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_483_652">
                      <rect width="20" height="20" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
                <p className="">info@transforma.in</p>
              </a>
            </div>
          </div>
        </div>
        <div className="bg-black">
          <div className="2xl:container mx-auto md:px-14 lg:px-20 px-6 flex w-full items-center flex-col gap-y-5 sm:flex-row justify-between py-3">
            <p className="text-white pt-2 text-14 ">
              {window.innerWidth > 769
                ? `© Copyright 2025 Transforma. All Rights Reserved.`
                : "© 2025 Transforma. All Rights Reserved."}
            </p>
            <div className="flex items-center gap-4 ">
              <Link
                to="https://www.linkedin.com/company/transforma-private-limited"
                className="text-16 text-white"
                target="_blank"
              >
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="28"
                    height="28"
                    rx="14"
                    stroke="white"
                    stroke-opacity="0.4"
                  />
                  <path
                    d="M10.925 21H8.1625V12.3063H10.925V21ZM9.54375 11.0875C8.65 11.0875 8 10.4375 8 9.54375C8 8.65 8.73125 8 9.54375 8C10.4375 8 11.0875 8.65 11.0875 9.54375C11.0875 10.4375 10.4375 11.0875 9.54375 11.0875ZM21 21H18.2375V16.2875C18.2375 14.9063 17.6687 14.5 16.8562 14.5C16.0437 14.5 15.2312 15.15 15.2312 16.3687V21H12.4688V12.3063H15.0687V13.525C15.3125 12.9563 16.2875 12.0625 17.6687 12.0625C19.2125 12.0625 20.8375 12.9562 20.8375 15.6375V21H21Z"
                    fill="white"
                  />
                </svg>
              </Link>
              <Link
                to="https://www.facebook.com/www.transforma.in"
                className="text-16 text-white "
                target="_blank"
              >
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="28"
                    height="28"
                    rx="14"
                    stroke="white"
                    stroke-opacity="0.4"
                  />
                  <path
                    d="M21 14.5C21 10.925 18.075 8 14.5 8C10.925 8 8 10.925 8 14.5C8 17.75 10.3562 20.4312 13.4437 20.9187V16.3687H11.8187V14.5H13.4437V13.0375C13.4437 11.4125 14.4188 10.5188 15.8813 10.5188C16.6125 10.5188 17.3438 10.6813 17.3438 10.6813V12.3063H16.5313C15.7188 12.3063 15.475 12.7938 15.475 13.2813V14.5H17.2625L16.9375 16.3687H15.3938V21C18.6438 20.5125 21 17.75 21 14.5Z"
                    fill="white"
                  />
                </svg>
              </Link>
              <Link
                to="https://twitter.com/i/flow/login?redirect_after_login=%2Ftransformapress"
                className="text-16 text-white"
                target="_"
              >
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="28"
                    height="28"
                    rx="14"
                    stroke="white"
                    stroke-opacity="0.4"
                  />
                  <path
                    d="M15.5097 13.6701L19.462 9.08301H18.5254L15.0937 13.066L12.3528 9.08301H9.19141L13.3362 15.106L9.19141 19.9163H10.1281L13.7521 15.7102L16.6467 19.9163H19.8081L15.5096 13.6701H15.5099H15.5097ZM14.2268 15.159L13.8069 14.5593L10.4655 9.78696H11.904L14.6006 13.6383L15.0206 14.2381L18.5259 19.2443H17.0873L14.2269 15.1592V15.1589L14.2268 15.159Z"
                    fill="white"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LandingFooter;
